var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalDriverSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 82.534,
    viewBox: "0 0 90 82.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(-326 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M412.974,42.94l-.664-1.506h1.061a2.55,2.55,0,0,0,0-5.1h-3.328l-2.664-6.022a3.406,3.406,0,0,0-3.111-2.027H402.1l-.844-2.355A2.9,2.9,0,0,0,398.528,24h-6.547a2.9,2.9,0,0,0-2.725,1.93l-.844,2.355h-2.123a3.412,3.412,0,0,0-3.111,2.027l-2.664,6.022h-3.328a2.55,2.55,0,0,0-.073,5.1h1.833a10.33,10.33,0,0,1,9.683,6.847l.132.352a11.162,11.162,0,0,1,10.032,6.653l.579,1.311h5.812v3.023a2.177,2.177,0,0,0,2.171,2.185h2.7a2.177,2.177,0,0,0,2.171-2.185V56.6h2.7A1.079,1.079,0,0,0,416,55.518V46.959a4.165,4.165,0,0,0-3.051-4.007ZM383.4,40.585l3.52-7.94h16.749l3.521,7.94Zm25.514,12.93h-.289a3.837,3.837,0,0,1,0-7.673h.289a3.837,3.837,0,0,1,0,7.673Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M329.726,59.743a2.177,2.177,0,0,0,2.17,2.185h2.7a2.177,2.177,0,0,0,2.171-2.185V56.72h5.812l.639-1.445a11.171,11.171,0,0,1,9.947-6.653l.133-.352a10.341,10.341,0,0,1,9.683-6.847H365.6a2.549,2.549,0,0,0-.76-4.978H361.51l-2.664-6.022a3.406,3.406,0,0,0-3.111-2.028h-2.171l-.844-2.355a2.9,2.9,0,0,0-2.725-1.93h-6.547a2.9,2.9,0,0,0-2.725,1.93l-.844,2.355h-2.123a3.412,3.412,0,0,0-3.111,2.028l-2.664,6.022h-3.328a2.55,2.55,0,0,0,0,5.1h1.061l-.663,1.506A4.151,4.151,0,0,0,326,47.056v8.559a1.079,1.079,0,0,0,1.073,1.081h2.641v3.023Zm8.657-26.965h16.749l3.521,7.94h-23.79ZM333.2,45.854h.3a3.994,3.994,0,0,1,0,7.989h-.3a3.994,3.994,0,0,1,0-7.989Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M343.4,96.287h11.094v6.8a3.435,3.435,0,0,1-3.425,3.448h-4.244a3.435,3.435,0,0,1-3.425-3.448Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M385.771,96.287h11.093v6.8a3.434,3.434,0,0,1-3.424,3.448H389.2a3.434,3.434,0,0,1-3.424-3.448Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M399.4,80.055H340.952l10.213-23.044a5.354,5.354,0,0,1,4.883-3.193h28.264a5.341,5.341,0,0,1,4.883,3.193l10.213,23.044Zm-47.918-6.872H388.87L383.335,60.7H357l-5.535,12.481Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M341.735,66.469h5.9a.32.32,0,0,1,.313.316v7.394a.32.32,0,0,1-.313.316h-5.9a4.019,4.019,0,0,1,0-8.037Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M398.6,74.494h-5.9a.32.32,0,0,1-.313-.316V66.785a.32.32,0,0,1,.313-.316h5.9a4.019,4.019,0,0,1,0,8.037Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M381.117,54.462h-21.97l1.556-4.346a4.542,4.542,0,0,1,4.28-3.023h10.285a4.56,4.56,0,0,1,4.281,3.023l1.555,4.346Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M396.273,76.607h-52.2a6.538,6.538,0,0,0-6.512,6.556V96.627a1.7,1.7,0,0,0,1.689,1.7h61.856a1.7,1.7,0,0,0,1.689-1.7V83.163a6.538,6.538,0,0,0-6.512-6.556ZM349.465,91.334h-.29a3.873,3.873,0,0,1,0-7.746h.29a3.873,3.873,0,0,1,0,7.746Zm29.71.741h-18a4.614,4.614,0,0,1,0-9.227h18a4.614,4.614,0,0,1,0,9.227Zm12.335-.741h-.289a3.873,3.873,0,0,1,0-7.746h.289a3.873,3.873,0,0,1,0,7.746Z",
    fill: "#c7c8c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDriverSmallIcon);
export default __webpack_public_path__ + "static/media/additional-driver-small-icon.64698444.svg";
export { ForwardRef as ReactComponent };